export const VEHICLE_BODY_TYPES = [
  "TENT",
  "REFRIGERATOR",
  "ISOTHERM",
  "VAN",
  "CONTAINER",
  "FLATBED",
  "MEGA",
  "PARAVOZ",
  "ISUZU",
  "BONGO",
  "GAZEL",
  "LABO",
  "SAMOSVAL",
  "SPECIAL",
  "OTHER",
];

// STAGE163M5A: richer list for EXPEDITOR -> My park only.
// DRIVER and EXPEDITOR both support explicit MEGA selection; richer expeditor-only types remain isolated below.
export const EXPEDITOR_PARK_BODY_TYPES = [
  "TENT",
  "CURTAIN_SIDE",
  "REFRIGERATOR",
  "ISOTHERM",
  "VAN",
  "CONTAINER",
  "FLATBED",
  "PLATFORM",
  "MEGA",
  "PARAVOZ",
  "SAMOSVAL",
  "TANKER",
  "GRAIN",
  "LOWBED",
  "CAR_CARRIER",
  "MANIPULATOR",
  "TOW_TRUCK",
  "CEMENT_MIXER",
  "ISUZU",
  "BONGO",
  "GAZEL",
  "LABO",
  "SPECIAL",
  "OTHER",
];

export const MARKET_VEHICLE_TYPES = [
  "TENT",
  "REFRIGERATOR",
  "ISOTHERM",
  "VAN",
  "CONTAINER",
  "FLATBED",
  "LABO",
  "BONGO",
  "GAZEL",
  "ISUZU",
  "KAMAZ",
  "CHAKMAN",
  "MEGA",
  "PARAVOZ",
  "SAMOSVAL",
  "PLATFORM",
  "SPECIAL",
  "OTHER",
];

export const FREIGHT_TRUCK_TYPES = [
  "TENT",
  "REF",
  "ISOTHERM",
  "BOX",
  "CONTAINER",
  "PLATFORM",
  "MEGA",
  "PARAVOZ",
  "ISUZU",
  "BONGO",
  "SAMOSVAL",
  "GAZEL",
  "LABO",
  "SPECIAL",
  "OTHER",
];

export const SPECIAL_EQUIPMENT_SUBTYPES = [
  "Экскаватор",
  "Экскаватор-погрузчик",
  "Фронтальный погрузчик",
  "Автокран",
  "Манипулятор",
  "Бульдозер",
  "Автовышка",
  "Каток",
  "Бетоносмеситель",
  "Вилочный погрузчик",
  "Мини-погрузчик",
  "Эвакуатор",
  "Трактор",
  "Другая спецтехника"
];

// REISOR_PHASE2_SPECIAL_SUBTYPE_I18N_V1
export const SPECIAL_EQUIPMENT_SUBTYPE_LABELS = {
  "Экскаватор": {
    ru: "Экскаватор",
    uz: "Экскаватор",
    tr: "Ekskavatör",
  },
  "Экскаватор-погрузчик": {
    ru: "Экскаватор-погрузчик",
    uz: "Экскаватор-юклагич",
    tr: "Kazıcı yükleyici",
  },
  "Фронтальный погрузчик": {
    ru: "Фронтальный погрузчик",
    uz: "Фронтал юклагич",
    tr: "Ön yükleyici",
  },
  "Автокран": {
    ru: "Автокран",
    uz: "Автокран",
    tr: "Mobil vinç",
  },
  "Манипулятор": {
    ru: "Манипулятор",
    uz: "Манипулятор",
    tr: "Vinçli kamyon",
  },
  "Бульдозер": {
    ru: "Бульдозер",
    uz: "Бульдозер",
    tr: "Buldozer",
  },
  "Автовышка": {
    ru: "Автовышка",
    uz: "Автовышка",
    tr: "Sepetli platform",
  },
  "Каток": {
    ru: "Каток",
    uz: "Йўл катоги",
    tr: "Silindir",
  },
  "Бетоносмеситель": {
    ru: "Бетоносмеситель",
    uz: "Бетон аралаштиргич",
    tr: "Beton mikseri",
  },
  "Вилочный погрузчик": {
    ru: "Вилочный погрузчик",
    uz: "Вилкали юклагич",
    tr: "Forklift",
  },
  "Мини-погрузчик": {
    ru: "Мини-погрузчик",
    uz: "Мини юклагич",
    tr: "Mini yükleyici",
  },
  "Эвакуатор": {
    ru: "Эвакуатор",
    uz: "Эвакуатор",
    tr: "Çekici",
  },
  "Трактор": {
    ru: "Трактор",
    uz: "Трактор",
    tr: "Traktör",
  },
  "Другая спецтехника": {
    ru: "Другая спецтехника",
    uz: "Бошқа махсус техника",
    tr: "Diğer özel ekipman",
  },
};

function currentVehicleCatalogLanguage(
  input = ""
) {
  let raw =
    String(input || "")
      .trim()
      .toLowerCase();

  if (
    !raw &&
    typeof document !== "undefined"
  ) {
    raw =
      String(
        document.documentElement
          ?.lang || ""
      )
        .trim()
        .toLowerCase();
  }

  if (
    !raw &&
    typeof localStorage !== "undefined"
  ) {
    try {
      raw =
        String(
          localStorage.getItem(
            "i18nextLng"
          ) ||
          localStorage.getItem(
            "language"
          ) ||
          localStorage.getItem(
            "lang"
          ) ||
          ""
        )
          .trim()
          .toLowerCase();
    } catch {}
  }

  if (raw.startsWith("uz")) {
    return "uz";
  }

  if (raw.startsWith("tr")) {
    return "tr";
  }

  return "ru";
}

export function specialEquipmentSubtypeLabel(
  value,
  language = ""
) {
  const key =
    String(value || "").trim();

  const item =
    SPECIAL_EQUIPMENT_SUBTYPE_LABELS[
      key
    ];

  if (!item) {
    return key;
  }

  const lang =
    currentVehicleCatalogLanguage(
      language
    );

  return (
    item[lang] ||
    item.ru ||
    key
  );
}


const CATALOG = {
  TENT: { icon: "tent", capacity: "25", volume: "96", ru: "Тент", uz: "Тент", tr: "Tenteli" },
  REFRIGERATOR: { icon: "cold", capacity: "22", volume: "86", ru: "Рефрижератор", uz: "Рефрижератор", tr: "Frigorifik" },
  REF: { aliasOf: "REFRIGERATOR", icon: "cold", capacity: "22", volume: "86", ru: "Рефрижератор", uz: "Рефрижератор", tr: "Frigorifik" },
  ISOTHERM: { icon: "box", capacity: "22", volume: "86", ru: "Изотерм", uz: "Изотерм", tr: "İzoterm" },
  VAN: { icon: "van", capacity: "2.5", volume: "10", ru: "Фургон", uz: "Фургон", tr: "Kapalı kasa" },
  BOX: { aliasOf: "VAN", icon: "van", capacity: "10", volume: "40", ru: "Фургон", uz: "Фургон", tr: "Kapalı kasa" },
  CONTAINER: { icon: "container", capacity: "25", volume: "76", ru: "Контейнеровоз", uz: "Контейнер ташувчи", tr: "Konteyner taşıyıcı" },
  FLATBED: { icon: "platform", capacity: "25", volume: "", ru: "Бортовой / платформа", uz: "Бортли / платформа", tr: "Platform" },
  PLATFORM: { aliasOf: "FLATBED", icon: "platform", capacity: "25", volume: "", ru: "Платформа", uz: "Платформа", tr: "Platform" },
  PARAVOZ: { icon: "trailer", capacity: "25", volume: "105", ru: "Фура / паровоз", uz: "Фура / паровоз", tr: "Römorklu" },
  ISUZU: { icon: "medium", capacity: "5", volume: "19", ru: "Исузу", uz: "Исузу", tr: "Isuzu" },
  BONGO: { icon: "small", capacity: "2", volume: "8.5", ru: "Бонго", uz: "Бонго", tr: "Bongo" },
  GAZEL: { icon: "small", capacity: "4", volume: "19", ru: "Газель", uz: "Газель", tr: "Gazelle" },
  SAMOSVAL: { icon: "dump", capacity: "25", volume: "", ru: "Самосвал", uz: "Самосвал", tr: "Damperli" },
  LABO: { icon: "small", capacity: "0.7", volume: "3.3", ru: "Лабо", uz: "Лабо", tr: "Labo" },
  KAMAZ: { icon: "medium", capacity: "", volume: "", ru: "КамАЗ", uz: "КамАЗ", tr: "KamAZ" },
  CHAKMAN: { icon: "medium", capacity: "", volume: "", ru: "Шакман", uz: "Шакман", tr: "Shacman" },
  MEGA: { icon: "tent", capacity: "", volume: "", ru: "Mega", uz: "Mega", tr: "Mega" },
  CURTAIN_SIDE: { icon: "tent", capacity: "25", volume: "96", ru: "Штора", uz: "Штора", tr: "Perdeli" },
  TANKER: { icon: "container", capacity: "25", volume: "", ru: "Цистерна", uz: "Цистерна", tr: "Tanker" },
  GRAIN: { icon: "dump", capacity: "25", volume: "", ru: "Зерновоз", uz: "Дон ташувчи", tr: "Tahıl taşıyıcı" },
  LOWBED: { icon: "platform", capacity: "", volume: "", ru: "Трал / низкорамная", uz: "Трал / паст рамали", tr: "Lowbed" },
  CAR_CARRIER: { icon: "trailer", capacity: "", volume: "", ru: "Автовоз", uz: "Автовоз", tr: "Oto taşıyıcı" },
  MANIPULATOR: { icon: "medium", capacity: "", volume: "", ru: "Манипулятор", uz: "Манипулятор", tr: "Vinçli kamyon" },
  TOW_TRUCK: { icon: "platform", capacity: "", volume: "", ru: "Эвакуатор", uz: "Эвакуатор", tr: "Çekici" },
  CEMENT_MIXER: { icon: "medium", capacity: "", volume: "", ru: "Бетономешалка", uz: "Бетон аралаштиргич", tr: "Beton mikseri" },
  SPECIAL: { icon: "medium", capacity: "", volume: "", ru: "Спецтехника", uz: "Махсус техника", tr: "Özel ekipman" },
  OTHER: { icon: "other", capacity: "", volume: "", ru: "Другое", uz: "Бошқа", tr: "Diğer" },
};

export function normalizeVehicleLanguage(value) {
  const raw = String(value || "ru").toLowerCase();
  if (raw.startsWith("uz")) return "uz";
  if (raw.startsWith("tr")) return "tr";
  return "ru";
}

export function vehicleTypeLabel(code, lang = "ru") {
  const key = String(code || "").trim().toUpperCase();
  if (!key) return "";
  const item = CATALOG[key];
  const lng = normalizeVehicleLanguage(lang);
  return item?.[lng] || item?.ru || key;
}

export function vehicleTypeMeta(code, lang = "ru") {
  const key = String(code || "").trim().toUpperCase();
  const item = CATALOG[key];
  if (!item) return "";
  const lng = normalizeVehicleLanguage(lang);
  const parts = [];
  if (item.capacity) {
    if (lng === "uz") parts.push(`${item.capacity} т гача`);
    else if (lng === "tr") parts.push(`${item.capacity} t'ye kadar`);
    else parts.push(`до ${item.capacity} т`);
  }
  if (item.volume) {
    if (lng === "uz") parts.push(`${item.volume} м³ гача`);
    else if (lng === "tr") parts.push(`${item.volume} m³'e kadar`);
    else parts.push(`до ${item.volume} м³`);
  }
  return parts.join(" · ");
}

export function vehicleTypeOptions(domain = "vehicle") {
  const keys = domain === "freight"
    ? FREIGHT_TRUCK_TYPES
    : domain === "market"
      ? MARKET_VEHICLE_TYPES
      : domain === "expeditorPark"
        ? EXPEDITOR_PARK_BODY_TYPES
        : VEHICLE_BODY_TYPES;
  return keys.map((code) => ({ code, ...CATALOG[code] }));
}

export function vehicleTypeIconKey(code) {
  return CATALOG[String(code || "").trim().toUpperCase()]?.icon || "other";
}
